function ZavLoader({ fullPage = false, top = false, text = "Loading..." }) {
  return (
    <div
      className={
        fullPage
          ? `fixed inset-0 z-[9999] flex justify-center bg-white/70 backdrop-blur-sm ${
              top ? "items-start pt-16 sm:pt-24" : "items-center"
            }`
          : "flex flex-col items-center justify-center gap-4 py-12"
      }
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="stethoscope-loader" aria-label="Loading">
          <svg
            viewBox="0 0 120 120"
            className="stethoscope-svg"
            role="img"
          >
            {/* Base stethoscope */}
            <path
              className="stethoscope-base"
              d="M35 18 V48 C35 65 48 78 60 78 C72 78 85 65 85 48 V18"
              fill="none"
            />

            <circle className="ear-piece" cx="35" cy="18" r="6" />
            <circle className="ear-piece" cx="85" cy="18" r="6" />

            <path
              className="stethoscope-base"
              d="M60 78 V91 C60 102 69 111 80 111 C91 111 100 102 100 91"
              fill="none"
            />

            <circle className="chest-piece-base" cx="100" cy="91" r="12" />

            {/* Animated fill stroke */}
            <path
              className="stethoscope-fill"
              d="M35 18 V48 C35 65 48 78 60 78 C72 78 85 65 85 48 V18"
              fill="none"
            />

            <path
              className="stethoscope-fill delay"
              d="M60 78 V91 C60 102 69 111 80 111 C91 111 100 102 100 91"
              fill="none"
            />

            <circle className="chest-piece-fill" cx="100" cy="91" r="12" />
          </svg>
        </div>

        {text ? <p className="loader-text">{text}</p> : null}
      </div>

      <style jsx>{`
        .stethoscope-loader {
          width: 84px;
          height: 84px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .stethoscope-svg {
          width: 84px;
          height: 84px;
          overflow: visible;
        }

        .stethoscope-base {
          stroke: #d1d5db;
          stroke-width: 8;
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .ear-piece {
          fill: #111827;
        }

        .chest-piece-base {
          fill: none;
          stroke: #d1d5db;
          stroke-width: 8;
        }

        .stethoscope-fill {
          stroke: #020617;
          stroke-width: 8;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 220;
          stroke-dashoffset: 220;
          animation: fillStroke 1.9s ease-in-out infinite;
        }

        .stethoscope-fill.delay {
          stroke-dasharray: 170;
          stroke-dashoffset: 170;
          animation-delay: 0.35s;
        }

        .chest-piece-fill {
          fill: none;
          stroke: #020617;
          stroke-width: 8;
          stroke-dasharray: 80;
          stroke-dashoffset: 80;
          transform-origin: 100px 91px;
          animation: fillCircle 1.9s ease-in-out infinite;
        }

        .loader-text {
          margin: 0;
          font-size: 13px;
          font-weight: 500;
          color: #0f172a;
          letter-spacing: 0.2px;
          animation: fadePulse 1.5s ease-in-out infinite;
        }

        @keyframes fillStroke {
          0% {
            stroke-dashoffset: 220;
            opacity: 0.35;
          }

          45% {
            stroke-dashoffset: 0;
            opacity: 1;
          }

          70% {
            stroke-dashoffset: 0;
            opacity: 1;
          }

          100% {
            stroke-dashoffset: -220;
            opacity: 0.35;
          }
        }

        @keyframes fillCircle {
          0% {
            stroke-dashoffset: 80;
            opacity: 0.35;
            transform: scale(0.96);
          }

          45% {
            stroke-dashoffset: 0;
            opacity: 1;
            transform: scale(1);
          }

          70% {
            stroke-dashoffset: 0;
            opacity: 1;
            transform: scale(1);
          }

          100% {
            stroke-dashoffset: -80;
            opacity: 0.35;
            transform: scale(0.96);
          }
        }

        @keyframes fadePulse {
          0%,
          100% {
            opacity: 0.45;
          }

          50% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default ZavLoader;